import { Container } from 'react-bootstrap';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import CookieConsent from './components/layout/CookieConsent';
import ScrollToTop from './components/layout/ScrollToTop';
import AuthHandler from './components/route/AuthHandler';
import { useGetPublicCompaniesQuery } from './slices/companyApiSlice';

const App = () => {
    // Fetch companies globally to populate the slice
    useGetPublicCompaniesQuery();

    const location = useLocation();
    const isInStorePriceCheckerRoute = /^\/in-store-price-checker\/?$/.test(location.pathname);
    const isProductRoute = /^\/product\/[^/]+\/?$/.test(location.pathname);
    const mainClassName = isInStorePriceCheckerRoute
        ? 'py-0'
        : `py-3${isProductRoute ? ' app-main-product' : ''}`;

    return (
        <>
            <ScrollToTop />
            <AuthHandler />
            {!isInStorePriceCheckerRoute && <Header />}
            <div id="app-content">
                <main className={mainClassName}>
                    {isInStorePriceCheckerRoute ? (
                        <Outlet />
                    ) : (
                        <Container>
                            <Outlet />
                        </Container>
                    )}
                </main>
            </div>
            {!isInStorePriceCheckerRoute && <Footer />}
            <CookieConsent />
            <ToastContainer
                position="bottom-right"
                autoClose={3200}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                theme="light"
                transition={Slide}
                limit={2}
                className="hs-toast-container"
                toastClassName="hs-toast"
                bodyClassName="hs-toast-body"
                progressClassName="hs-toast-progress"
            />
        </>
    );
};

export default App;
